import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';

const QualitySectionCard = ({ title, subtitle, action, children, sx = {} }) => (
  <Card
    elevation={0}
    sx={{
      height: '100%',
      borderRadius: 3,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      background: (theme) =>
        theme.palette.mode === 'dark'
          ? 'rgba(255,255,255,0.02)'
          : 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.5))',
      display: 'flex',
      flexDirection: 'column',
      ...sx,
    }}
  >
    <CardHeader
      title={title}
      subheader={subtitle}
      action={action}
      sx={{
        '& .MuiCardHeader-title': { fontWeight: 700 },
        '& .MuiCardHeader-subheader': { opacity: 0.7 },
        pb: 0,
      }}
    />
    <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>{children}</CardContent>
  </Card>
);

export default QualitySectionCard;


